(() => {
  const roots = Array.from(document.querySelectorAll('.starter-kit-bundle-mapper'));
  if (roots.length === 0) return;

  function normalizeText(s) {
    return (s || '').toString().toLowerCase();
  }

  function variantText(v) {
    const parts = [];
    if (v?.title) parts.push(v.title);
    if (v?.public_title) parts.push(v.public_title);
    if (v?.option1) parts.push(v.option1);
    if (v?.option2) parts.push(v.option2);
    if (v?.option3) parts.push(v.option3);
    return normalizeText(parts.join(' '));
  }

  function baseVariantText(v) {
    const parts = [];
    if (v?.title) parts.push(v.title);
    if (v?.option1) parts.push(v.option1);
    if (v?.option2) parts.push(v.option2);
    if (v?.option3) parts.push(v.option3);
    return normalizeText(parts.join(' '));
  }

  function hasInch(text, n) {
    if (!text) return false;
    // Match: 3", 3”, 3 in, 3 inch, 3 inches
    const re = new RegExp(`\\b${n}\\s*(?:["”]|in(?:ch|ches)?\\b)`, 'i');
    return re.test(text);
  }

  function getBundleById(relatedBundles, id) {
    const target = Number(id);
    if (!Number.isFinite(target)) return null;
    return (relatedBundles || []).find((b) => Number(b?.id) === target) || null;
  }

  function pickFirstAvailableVariant(bundle) {
    if (!bundle?.variants || !Array.isArray(bundle.variants)) return null;
    return bundle.variants.find((v) => v.available) || bundle.variants[0] || null;
  }

  function pickVariantByDepth(bundle, depth /* '3' | '4' */) {
    if (!bundle?.variants || !Array.isArray(bundle.variants)) return null;
    if (!depth) return pickFirstAvailableVariant(bundle);

    const matches = bundle.variants.filter((v) => hasInch(variantText(v), depth));
    if (matches.length === 0) return pickFirstAvailableVariant(bundle);
    return matches.find((v) => v.available) || matches[0] || null;
  }

  function extractPackNumberFromVariant(variant) {
    const candidates = [];
    if (variant?.option1) candidates.push(variant.option1);
    if (variant?.option2) candidates.push(variant.option2);
    if (variant?.option3) candidates.push(variant.option3);
    if (variant?.public_title) candidates.push(variant.public_title);
    if (variant?.title) candidates.push(variant.title);

    // Prefer explicit "12 Pack(s)" patterns
    for (const c of candidates) {
      const m = (c || '').toString().match(/(\d+)\s*(?:pack|packs)\b/i);
      if (m) return Number(m[1]);
    }

    // Fallback: accept known pack sizes embedded in strings
    for (const c of candidates) {
      const m = (c || '').toString().match(/\b(6|8|12|16|24|32|64|72|120)\b/);
      if (m) return Number(m[1]);
    }

    return null;
  }

  function pickVariantByPack(bundle, packNumber) {
    if (!bundle?.variants || !Array.isArray(bundle.variants)) return null;
    const target = Number(packNumber);
    if (!Number.isFinite(target) || !target) return pickFirstAvailableVariant(bundle);

    const matches = bundle.variants.filter((v) => extractPackNumberFromVariant(v) === target);
    if (matches.length === 0) return pickFirstAvailableVariant(bundle);
    return matches.find((v) => v.available) || matches[0] || null;
  }

  function setIntelligemsPriceAttrs(el, variant) {
    if (!el || !variant?.id) return;
    el.setAttribute('data-variant-id', String(variant.id));
    if (variant.product_id) el.setAttribute('data-product-id', String(variant.product_id));
  }

  function refreshIntelligemsPrices() {
    if (typeof window.igData?.resetDom === 'function') window.igData.resetDom();
  }

  function detectKitType(baseVariant) {
    const t = baseVariantText(baseVariant);
    if (t.includes('mixed')) return 'mixed';
    if (t.includes('6-cell') || t.includes('6 cell')) return 'six';
    if (t.includes('4-cell') || t.includes('4 cell')) return 'four';
    return null;
  }

  function detectDepth(baseVariant) {
    const t = baseVariantText(baseVariant);
    if (hasInch(t, 3)) return '3';
    if (hasInch(t, 4)) return '4';
    return null;
  }

  function updateThemePrice(root, variant) {
    if (!variant) return false;
    const sectionId = root.getAttribute('data-section-id') || '';
    const scope =
      (sectionId && document.getElementById('ProductInfo-' + sectionId)) ||
      root.closest('.product__info-container') ||
      root.closest('.product__info-wrapper') ||
      document;

    const priceBlock = scope.querySelector('.no-js-hidden[id^="price-"]') || scope.querySelector('[id^="price-"]');
    const priceCandidates = priceBlock ? Array.from(priceBlock.querySelectorAll('.price')) : [];
    const priceRoot =
      priceCandidates.find((el) => el.querySelector('.price__sale, .price__regular')) ||
      priceBlock?.closest('.price') ||
      null;
    if (!priceBlock || !priceRoot) return false;

    const saleWrap = priceRoot.querySelector('.price__sale');
    const regularWrap = priceRoot.querySelector('.price__regular');

    const salePriceEl = saleWrap?.querySelector('.price-item--sale.price-item--last');
    const comparePriceEl = saleWrap?.querySelector('.price-item--regular');
    const regularPriceEl = regularWrap?.querySelector('.price-item--regular');

    const unitPriceCents = Number(variant?.price);
    const unitCompareCents = Number(variant?.compare_at_price);
    const priceCents = Number.isFinite(unitPriceCents) ? unitPriceCents : 0;
    const compareCents = Number.isFinite(unitCompareCents) ? unitCompareCents : NaN;
    const isOnSale = Number.isFinite(compareCents) && Number.isFinite(priceCents) && compareCents > priceCents;

    const hasSaleMarkup = !!saleWrap && !!salePriceEl;
    const hasRegularMarkup = !!regularWrap && !!regularPriceEl;

    // Some templates only render sale markup; keep the layout stable.
    const shouldShowSaleLayout = isOnSale || (hasSaleMarkup && !hasRegularMarkup);
    priceRoot.classList.toggle('price--on-sale', shouldShowSaleLayout);
    priceRoot.classList.toggle('price--sold-out', !variant.available);

    const formatMoney = (cents) => (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    const saleText = formatMoney(priceCents || 0);
    const compareText = isOnSale ? formatMoney(compareCents) : '';

    if (salePriceEl) salePriceEl.textContent = saleText;
    if (regularPriceEl) regularPriceEl.textContent = saleText;
    if (comparePriceEl) comparePriceEl.textContent = compareText;
    [priceRoot, salePriceEl, regularPriceEl, comparePriceEl].forEach((el) => setIntelligemsPriceAttrs(el, variant));

    if (comparePriceEl) {
      const compareContainer = comparePriceEl.closest('span') || comparePriceEl.parentElement;
      if (compareContainer && compareContainer.style) {
        compareContainer.style.display = isOnSale ? '' : 'none';
      }
    }

    refreshIntelligemsPrices();
    return true;
  }

  async function addVariantToCart(variantId, quantity) {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(quantity));

    if (cart && cart.getSectionsToRender) {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }

    const config = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    const res = await fetch(`${routes.cart_add_url}`, config);
    const json = await res.json();

    if (json.status) {
      throw new Error(json.description || json.message || 'Unable to add to cart.');
    }

    if (cart && cart.renderContents) {
      cart.renderContents(json);
      if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    }

    return json;
  }

  roots.forEach((root) => {
    const sectionId = root.getAttribute('data-section-id') || '';
    const dataEl = sectionId ? document.getElementById('starter-kit-bundle-mapper-data-' + sectionId) : null;
    if (!sectionId || !dataEl) return;

    let data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    let relatedBundles = Array.isArray(data?.relatedBundles) ? data.relatedBundles : [];
    const ids = data?.bundleProductIds || {};

    let currentMappedVariant = null;

    function setHint(msg) {
      const hint = root.querySelector('.starter-kit-bundle-mapper__hint') || root.querySelector('.gcb__hint');
      if (!hint) return;
      hint.textContent = msg || '';
    }

    function getRequiredBundleIds() {
      return [ids.fourCellKit, ids.sixCellKit, ids.mixedKit]
        .map((x) => Number(x))
        .filter((n) => Number.isFinite(n) && n > 0);
    }

    function hasRelatedBundles() {
      return Array.isArray(relatedBundles) && relatedBundles.length > 0;
    }

    function setButtonState(mappedVariant) {
      const btn = document.getElementById('ProductSubmitButton-' + sectionId);
      if (!btn) return;

      const label = btn.querySelector('span');

      if (mappedVariant && mappedVariant.available) {
        // Make it behave like an Add to Cart button (but we'll handle click).
        btn.type = 'button';
        btn.classList.remove('button--secondary', 'bis-notify-button');
        btn.classList.add('button--primary');
        btn.removeAttribute('data-modal-target');
        if (label) label.textContent = (window?.variantStrings?.addToCart) || 'Add to Cart';
        btn.disabled = false;
        return;
      }

      // Fallback to Notify behavior
      btn.type = 'button';
      btn.classList.remove('button--primary');
      btn.classList.add('button--secondary', 'bis-notify-button');
      btn.setAttribute('data-modal-target', 'back-in-stock-modal-' + sectionId);
      if (label) label.textContent = 'Notify Me When Available';
      btn.disabled = false;
    }

    function pickMappedVariant(baseVariant) {
      if (!baseVariant) return null;
      if (!relatedBundles.length) return null;

      const kitType = detectKitType(baseVariant);
      const depth = detectDepth(baseVariant);

      if (kitType === 'mixed') {
        const bundle = getBundleById(relatedBundles, ids.mixedKit);
        const variant = pickFirstAvailableVariant(bundle);
        return { bundle, variant };
      }

      if (kitType === 'six') {
        const bundle = getBundleById(relatedBundles, ids.sixCellKit);
        const variant = pickVariantByPack(bundle, 12);
        return { bundle, variant };
      }

      // Default: 4-cell kit (3" or 4" depth)
      const bundle = getBundleById(relatedBundles, ids.fourCellKit);
      const variant = pickVariantByDepth(bundle, depth);
      return { bundle, variant };
    }

    function getCurrentBaseVariantFromTheme() {
      const productInfo = document.getElementById('ProductInfo-' + sectionId);
      const selector = productInfo?.querySelector('variant-radios, variant-selects');
      const jsonEl = selector?.querySelector('[type="application/json"]');
      const input = document.querySelector(`#product-form-${sectionId} input[name="id"]`);
      if (!jsonEl || !input) return null;

      let variants;
      try {
        variants = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return null;
      }
      const id = Number(input.value);
      if (!Number.isFinite(id)) return null;
      return (variants || []).find((v) => Number(v?.id) === id) || null;
    }

    function syncVariantPickerAvailabilityFromMappedBundle() {
      if (!hasRelatedBundles()) return;

      const productInfo = document.getElementById('ProductInfo-' + sectionId);
      const selector = productInfo?.querySelector('variant-radios, variant-selects');
      const jsonEl = selector?.querySelector('[type="application/json"]');
      if (!productInfo || !selector || !jsonEl) return;

      let baseVariants;
      try {
        baseVariants = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }
      if (!Array.isArray(baseVariants) || baseVariants.length === 0) return;

      // Map option value -> mapped bundle availability.
      // For this PDP (starter kit), the option1 values are 1:1 with variants.
      const mappedAvailabilityByValue = new Map();
      for (const v of baseVariants) {
        const value = (v?.option1 || v?.title || '').toString();
        if (!value) continue;
        const mapped = pickMappedVariant(v);
        const mappedAvailable = !!mapped?.variant && !!mapped.variant.available;
        mappedAvailabilityByValue.set(normalizeText(value), mappedAvailable);
      }

      // Button-style variant picker
      const radios = Array.from(productInfo.querySelectorAll(`.product-form__input input[type="radio"][form="product-form-${sectionId}"]`));
      radios.forEach((input) => {
        const key = normalizeText(input?.value);
        if (!mappedAvailabilityByValue.has(key)) return;

        const isAvailable = mappedAvailabilityByValue.get(key);
        // Keep options selectable; use `.disabled` only for strike-through styling.
        input.classList.toggle('disabled', !isAvailable);
      });

      // Dropdown-style variant picker
      const selects = Array.from(productInfo.querySelectorAll(`.product-form__input select[form="product-form-${sectionId}"]`));
      selects.forEach((select) => {
        const options = Array.from(select?.options || []);
        options.forEach((opt) => {
          const key = normalizeText(opt?.value);
          if (!mappedAvailabilityByValue.has(key)) return;
          const isAvailable = mappedAvailabilityByValue.get(key);

          // Keep the label in sync if theme rendered " - Unavailable"
          const baseLabel = (opt?.value || '').toString();
          if (!baseLabel) return;
          opt.textContent = isAvailable ? baseLabel : `${baseLabel} - Unavailable`;
        });
      });
    }

    function applyMapping(baseVariant) {
      const btn = document.getElementById('ProductSubmitButton-' + sectionId);
      if (!btn) return;

      const mapped = pickMappedVariant(baseVariant);
      const mappedVariant = mapped?.variant || null;
      currentMappedVariant = mappedVariant;

      if (!mappedVariant) {
        // If bundles aren't loaded yet, don't show an error (we'll show a config hint elsewhere).
        if (!relatedBundles.length) {
          setHint('');
          setButtonState(null);
          return;
        }

        setButtonState(null);

        const kitType = detectKitType(baseVariant);
        const depth = detectDepth(baseVariant);

        let expectedBundleId = null;
        if (kitType === 'mixed') expectedBundleId = ids.mixedKit;
        if (kitType === 'six') expectedBundleId = ids.sixCellKit;
        if (kitType === 'four') expectedBundleId = ids.fourCellKit;

        if (!kitType) {
          setHint('Unable to determine kit type for the selected variant.');
          return;
        }

        const bundle = expectedBundleId ? getBundleById(relatedBundles, expectedBundleId) : null;
        if (!bundle) {
          setHint(`Missing mapped virtual bundle product${expectedBundleId ? ` (ID: ${expectedBundleId})` : ''} in PDP Related Bundles.`);
          return;
        }

        const bundleVariants = Array.isArray(bundle.variants) ? bundle.variants : [];
        if (bundleVariants.length === 0) {
          setHint('Mapped virtual bundle product has no variants.');
          return;
        }

        if (kitType === 'four' && depth) {
          setHint(`Unable to find a ${depth}" virtual bundle variant for this selection.`);
          return;
        }

        setHint('Unable to map this selection to a virtual bundle variant.');
        return;
      }

      setHint('');
      setButtonState(mappedVariant);
      updateThemePrice(root, mappedVariant);
    }

    async function applyMappingWithBundles(baseVariant) {
      if (!hasRelatedBundles()) {
        currentMappedVariant = null;
        setButtonState(null);

        const required = getRequiredBundleIds();
        const idsText = required.length ? required.join(', ') : '';
        setHint(
          idsText
            ? `Missing PDP Related Bundles virtual bundle products for this PDP. Add these bundle products to the product metafield “PDP Related Bundles” and publish them to the Online Store sales channel: ${idsText}.`
            : 'Missing PDP Related Bundles virtual bundle products for this PDP. (Set the product metafield “PDP Related Bundles” and ensure bundle products are published to the Online Store sales channel.)'
        );
        return;
      }

      applyMapping(baseVariant);
      // Ensure the variant option strike-through reflects mapped bundle inventory
      // (not the base product variant inventory).
      syncVariantPickerAvailabilityFromMappedBundle();
    }

    // Click-to-add behavior (uses the mapped variant)
    const button = document.getElementById('ProductSubmitButton-' + sectionId);
    if (button) {
      button.addEventListener('click', async (e) => {
        if (!currentMappedVariant?.id || !currentMappedVariant.available) return;

        e.preventDefault();
        if (button.dataset.egAtcState === 'pending') return;

        // Quantity input is usually outside the form (with a `form` attribute), so read it directly.
        const qtyInput = document.getElementById('Quantity-' + sectionId) || document.querySelector(`#product-form-${sectionId} [name="quantity"]`);
        const qty = Math.max(1, Number.parseInt(qtyInput?.value || '1', 10) || 1);

        // Loading UI (match theme pattern)
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        window.EGAtcFeedback?.pending(button);
        const spinner = button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        try {
          await addVariantToCart(currentMappedVariant.id, qty);
          window.EGAtcFeedback?.success(button);
        } catch (err) {
          setHint(err?.message || 'Unable to add to cart.');
        } finally {
          button.classList.remove('loading');
          window.EGAtcFeedback?.idle(button);
          button.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        }
      });
    }

    // React to variant changes (Dawn pub/sub) if available, else fallback to change events.
    const subscribeFn = (typeof subscribe === 'function') ? subscribe : null;
    if (subscribeFn && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS?.variantChange) {
      subscribeFn(PUB_SUB_EVENTS.variantChange, (event) => {
        const eventSectionId = event?.data?.sectionId;
        if (eventSectionId !== sectionId) return;
        applyMappingWithBundles(event?.data?.variant || null);
      });
    } else {
      const productInfo = document.getElementById('ProductInfo-' + sectionId);
      const selector = productInfo?.querySelector('variant-radios, variant-selects');
      if (selector) {
        selector.addEventListener('change', () => {
          applyMappingWithBundles(getCurrentBaseVariantFromTheme());
        });
      }
    }

    // Initial sync
    applyMappingWithBundles(getCurrentBaseVariantFromTheme());
  });
})();
